import { gql } from '@apollo/client';

export const ADD_FILE_TO_PROFILE = gql`
  mutation AddFileToProfile($file: Upload) {
    addFileToProfile(file: $file) {
      success
      message
    }
  }
`;

export const DELETE_FILE_FROM_PROFILE = gql`
  mutation DeleteFileFromProfile($fileId: Int) {
    deleteFileFromProfile(fileId: $fileId) {
      success
      message
    }
  }
`;

export const EMPLOYER_ADD_FILE_TO_PROFILE = gql`
  mutation EmployerAddFileToProfile(
    $profileId: Int
    $file: Upload
  ) {
    employerAddFileToProfile(
      profileId: $profileId
      file: $file
    ) {
      success
      message
    }
  }
`;
